"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Preloader = void 0;
var once_1 = require("../utils/once");
var onOnline_1 = require("./onOnline");
var Preloader = (function () {
    function Preloader() {
        this.store = {};
        this.count = 0;
        this.once = new once_1.Once();
    }
    Object.defineProperty(Preloader.prototype, "loading", {
        get: function () {
            return this.count > 0;
        },
        enumerable: false,
        configurable: true
    });
    Preloader.prototype.loadImage = function (index, src, defaultView) {
        var _this = this;
        var current = this.store[index];
        if (current !== undefined)
            return;
        this.store[index] = null;
        var img = new Image();
        img.crossOrigin = 'anonymous';
        img.onload = function () {
            _this.store[index] = img;
            _this.count--;
            _this.checkSubscriber();
        };
        img.onerror = function () {
            console.error('Image load error: ' + src);
            _this.count--;
            _this.checkSubscriber();
            onOnline_1.onOnline(defaultView, function () {
                _this.store[index] = undefined;
                _this.loadImage(index, src, defaultView);
            });
        };
        img.src = src;
        this.count++;
    };
    Preloader.prototype.getImage = function (index) {
        return this.store[index] || null;
    };
    Preloader.prototype.subscribe = function (callback) {
        this.once.add(callback);
    };
    Preloader.prototype.checkSubscriber = function () {
        if (this.count > 0) {
            return;
        }
        this.once.emit();
    };
    return Preloader;
}());
exports.Preloader = Preloader;
//# sourceMappingURL=preloader.js.map